export class OSSAppDropdownClass {
  constructor(user, tenants, theme) {
    this.user = user;
    this.tenants = tenants;
    this.theme = theme;
    this.menuItems = [];
    this.allowed_urls = [];

    this.routeObject = {};
  }

  findAppsUserHasAccessTo = () => {
    this.allowed_urls = this.user?.allowed_urls ?? [];
  };

  generatePathnameObject = (config, actions) => {
    const { routes } = config;

    const allowedPaths = Object.entries(routes).filter(([name, route]) => {
      // Filter out this one
      const isNotHomeRoute = route.title !== "Home";

      // Filter out routes that have excludeFromMainNav is true
      const isNotExcluded = !route.excludeFromMainNav;

      // Filter out routes that have :id in them
      const doesNotHaveIdInUrl = !route.url.includes(":id");

      // Check if user has required permissions for this route
      const userHasRequiredPermissions =
        !route.requiredPermissions ||
        route?.requiredPermissions.every(perm => actions.includes(perm));

      if (
        isNotExcluded &&
        isNotHomeRoute &&
        doesNotHaveIdInUrl &&
        userHasRequiredPermissions
      ) {
        return [name, route];
      }
      return null;
    });

    if (allowedPaths?.length > 0) {
      return allowedPaths.map(([key, value]) => ({
        icon: config[key]?.headerIcon,
        color:
          this.theme?.palette?.catalogColors[config[key]?.headerColor]
            ?.primary ?? "black",
        ...value
      }));
    }
    return null;
  };

  sortAndDefineRouteObject = () => {
    // object key is the "source" from the user object,
    // object value is used to match the tenant object
    const fullCodenamesObject = {
      "yt-dv": "ytdv",
      fb: "facebook",
      tt: "tiktok",
      tw: "twitter",
      twitch: "twitch",
      openslate: "access",
      yt: "youtube"
    };

    const allActionsBySource = Object.entries(this.user.actions_by_source);

    allActionsBySource.forEach(([source, actions]) => {
      const truestCodename = fullCodenamesObject[source];
      // Check the route object for the key of the truest codename
      const tenantConfig = this.tenants[`${truestCodename}Config`] ?? null;

      const pathnameObject =
        tenantConfig && this.generatePathnameObject(tenantConfig, actions);

      if (pathnameObject) {
        const brand = tenantConfig?.brand;
        // And then append the pathname object generated
        this.routeObject[truestCodename] = {
          routes: pathnameObject,
          brand
        };
      }
    });
  };

  applyEnvironmentHostnames = () => {
    const brands = Object.entries(this.routeObject);

    brands.forEach(([brandname, routeObject]) => {
      const envhostnames = this.user.apps.filter(
        app =>
          app.url.toLowerCase().includes(brandname) ||
          (app.url.toLowerCase().includes("localhost") &&
            app.name.toLowerCase().includes(brandname))
      );
      this.routeObject[brandname] = {
        ...routeObject,
        hostname: envhostnames
      };
    });
  };

  generateAppAndRouteConfigs = () => {
    this.findAppsUserHasAccessTo();
    this.sortAndDefineRouteObject();
    this.applyEnvironmentHostnames();
  };
}
